import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { useMyCourseData } from 'Domain/MyCourseData';
import { useConfig } from 'Context/ConfigContext';
import useMyExternalProfile from 'Routes/Classroom/Domain/useMyExternalProfile';
import { myProfile } from 'Redux/user-profile/selectors';
import {
  validateIsGamificationUser,
  getSchoolIdFromUserName,
  generateGamificationUrl,
} from 'Util/gamificationHelper';
import { GAMIFICATION_JWT_SECRET } from 'Util/Capacitors/constant';

import GamificationModalView from './GamificationModal.view';

const GamificationModalContainer = ({ userName }) => {
  const [isTimerDone, setIsTimerDone] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(true);
  const [gamificationUrl, setGamificationUrl] = useState(null);

  const onOpenModal = () => setIsOpenModal(true);
  const onCloseModal = () => setIsOpenModal(false);

  const getGamificationUrl = async (payload, jwtSecret, gamificationBaseUrl) => {
    const url = await generateGamificationUrl(payload, jwtSecret, gamificationBaseUrl);
    if (!url) {
      return;
    }
    setGamificationUrl(url);
  };

  const gamificationConfig = useConfig()?.classroom?.quiz?.gamification ?? [];
  const gamificationLearnedSchools = gamificationConfig?.enabledLearnEdSchools ?? [];
  const gamificationTimeDelay = gamificationConfig?.modalDelay ?? 2000;

  const { data } = useMyExternalProfile({ fetchPolicy: 'cache-only' });
  const providerName = data?.myExternalProfile?.providerName ?? '';
  /**
   * !todo: we can get user's school name from additional7
   */
  const userSchoolName = getSchoolIdFromUserName(userName);
  const isGamificationUser = validateIsGamificationUser(
    gamificationLearnedSchools,
    providerName,
    userSchoolName
  );

  const courseCode = useMyCourseData()?.courseCode;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTimerDone(true);
    }, gamificationTimeDelay);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isGamificationUser) {
      const jwtPayLoad = {
        sub: userName.replace('learned.', ''),
        sid: userSchoolName,
        un: userName.replace('learned.', ''),
        cid: courseCode,
      };
      const gamificationBaseUrl = gamificationConfig?.baseUrl ?? [];
      const gamificationJwtSecretFromCapacitor = GAMIFICATION_JWT_SECRET;
      const gamificationJwtSecretFromConfig = gamificationConfig?.jwtSecret;
      const gamificationJwtSecret =
        gamificationJwtSecretFromCapacitor ?? gamificationJwtSecretFromConfig;
      getGamificationUrl(jwtPayLoad, gamificationJwtSecret, gamificationBaseUrl);
    }
  }, []);

  return (
    <GamificationModalView
      isTimerDone={isTimerDone}
      isOpen={isGamificationUser ? isOpenModal : false}
      gamificationUrl={gamificationUrl}
      onOpenModal={onOpenModal}
      onCloseModal={onCloseModal}
    />
  );
};

GamificationModalContainer.propTypes = {
  userName: PropTypes.string,
};

export default connect(
  (state) => ({ userName: myProfile(state)?.username }),
  {}
)(GamificationModalContainer);
